/**
 * The ISR a carrier withheld on a statement entered by hand is stated per currency: a
 * statement with lines in dollars states its ISR in dollars. The editor asks for one ISR per
 * currency present in its lines, and sends only those.
 */
export type IsrCurrency = 'GTQ' | 'USD';

const ORDER: IsrCurrency[] = ['GTQ', 'USD'];

/** The currencies whose ISR the editor asks for: those of the lines, quetzales first. */
export function isrCurrencies(lines: { currency: IsrCurrency }[]): IsrCurrency[] {
  return ORDER.filter((c) => lines.some((l) => l.currency === c));
}

/**
 * The withholding to send: the ISR typed for each currency of the lines, in that currency.
 * An empty or zero ISR means nothing was withheld; an ISR typed for a currency no line has
 * any more is not sent. `cents` reads a typed amount (and rejects what is not one).
 */
export function withholdingOf(
  typed: Partial<Record<IsrCurrency, string>>,
  currencies: IsrCurrency[],
  cents: (text: string) => number | null,
): { amountMinor: number; currency: IsrCurrency }[] {
  return currencies.flatMap((currency) => {
    const amountMinor = cents(typed[currency] ?? '');
    return amountMinor ? [{ amountMinor, currency }] : [];
  });
}
